const getDefaultState = (() => ({
    shareCapital : {},
    shareholdersAllotmentData : [],
    requestedBeneficialOwners : [],
    existingBeneficialOwners : [],
    requestedRegistrableControllers: [],
    existingRegistrableControllers: [],
    completeAllotment: {},
    shareAllotmentId: undefined,
    companyProcessId: undefined,
}));

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        getAll(state)
        {
            return state;
        },

        getShareCapital(state) {
            return state.shareCapital;
        },

        getShareholdersAllotmentData(state) {
            return state.shareholdersAllotmentData;
        },

        getRequestedBeneficialOwners(state) {
            return state.requestedBeneficialOwners;
        },

        getExistingBeneficialOwners(state) { 
            return state.existingBeneficialOwners;
        },

        getRequestedRegistrableControllers(state) {
            return state.requestedRegistrableControllers;
        },

        getExistingRegistrableControllers(state) {
            return state.existingRegistrableControllers;
        },

        getCompleteAllotment(state) {
            return state.completeAllotment;
        },
    },

    mutations: {
        CLEAR(state)
        {
            Object.assign(state, getDefaultState());
        },

        SET_SHARE_CAPITAL(state, shareCapital) {
            state.shareCapital = shareCapital;
        },

        SET_SHAREHOLDERS(state, shareholders) {
            state.shareholdersAllotmentData = shareholders;
        },

        SET_REQUESTED_BENEFICIAL_OWNERS(state, requestedBeneficialOwners) {
            state.requestedBeneficialOwners = requestedBeneficialOwners;
        },

        SET_EXISTING_BENEFICIAL_OWNERS(state, existingBeneficialOwners) {
            state.existingBeneficialOwners = existingBeneficialOwners;
        },

        SET_REQUESTED_REGISTRABLE_CONTROLLERS(state, requestedRegistrableControllers) {
            state.requestedRegistrableControllers = requestedRegistrableControllers;
        },

        SET_EXISTING_REGISTRABLE_CONTROLLERS(state, existingRegistrableControllers) {
            state.existingRegistrableControllers = existingRegistrableControllers;
        },

        SET_COMPLETE_ALLOTMENT(state, completeAllotment) {
            state.completeAllotment.signingDirector = completeAllotment.signing_director;
            state.completeAllotment.type = completeAllotment.type;
            state.completeAllotment.authorisationDate = completeAllotment.authorisation_date;
            state.completeAllotment.egmDate = completeAllotment.egm_date;
            state.completeAllotment.noticeDate = completeAllotment.notice_date;
            state.completeAllotment.regulationNumber = completeAllotment.regulation_number;
            state.completeAllotment.generateWaiver = completeAllotment.generate_waiver;
        },

        SET_SHARE_ALLOTMENT_ID(state, id) {
            state.shareAllotmentId = id;
        },

        SET_COMPANY_PROCESS_ID(state, id) {
            state.companyProcessId = id;
        }
    },

    actions: {
        SET_SHARE_ALLOTMENT_DATA({ commit }, shareAllotmentData) {
            // first clear all data
            commit('CLEAR');

            commit('SET_SHARE_CAPITAL', shareAllotmentData.share_capital_data);
            commit('SET_SHAREHOLDERS', shareAllotmentData.shareholders_allotment_data);
            commit('SET_REQUESTED_BENEFICIAL_OWNERS', shareAllotmentData.beneficial_owners_data.requestedBeneficialOwners);
            commit('SET_EXISTING_BENEFICIAL_OWNERS', shareAllotmentData.beneficial_owners_data.existingBeneficialOwners);
            commit('SET_REQUESTED_REGISTRABLE_CONTROLLERS', shareAllotmentData.registrable_controllers_data.requestedRegistrableControllers);
            commit('SET_EXISTING_REGISTRABLE_CONTROLLERS', shareAllotmentData.registrable_controllers_data.existingRegistrableControllers);
            commit('SET_COMPLETE_ALLOTMENT', shareAllotmentData);
        },
    },
};
